import { Component, OnInit } from '@angular/core';
import { OrderService, AuthenticationService, ScriptService } from '@app/core';
import { Order } from '@core/model/order.model';
import { Subject, Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { Paginated } from '@app/core/model/paginated.model';
import { finalize } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { FormControl } from '@angular/forms';
import { ProformaService } from '@app/core/service/proforma.service';

declare let pdfMake: any;

@Component({
  selector: 'app-proformas',
  templateUrl: './proformas.component.html',
  styleUrls: ['./proformas.component.css']
})
export class ProformasComponent implements OnInit {

  orders: Order[];

  pager = {};
  pageOfItems: any = [];
  // items = [ { name: 'PEDIDO'}, { name: 'DESPACHADO'}, { name: 'CONCLUIDO'}, { name: 'ANULADO'}];

  pedidos: Paginated;
  private searchTermStream = new Subject<string>();
  currentSearchTerm: string = null;
  currentUserSubscription: Subscription;

  currentUser: any;
  userid: string;

  isLoading = false;
  orden: any;
  selectedOption = 'PEDIDO';
  printedOption: any;
  estado: string;
  paginanum:number;
  Array: any = [];
  isfrmChecked:any;
  constructor(
    public orderService: OrderService,
    public proformaService:ProformaService,
    private scriptService: ScriptService,
    private authService: AuthenticationService,
    private datePipe: DatePipe
  ) {
    this.scriptService.load('pdfMake', 'vfsFonts');
  }

  ngOnInit() {
    this.scriptService.load('pdfMake', 'vfsFonts');

    this.currentUserSubscription = this.authService.currentUser.subscribe(
      user => {
        this.currentUser = user.data.user.id;
        //  console.log(this.currentUser.data.user);
        this.userid = this.currentUser;
      }
    );

    

    this.proformaService.search('', this.userid).then((proformas: any) => {
      this.currentSearchTerm = '';
      this.updatepedidos(proformas);
      console.log(proformas);
    });

    this.searchTermStream.subscribe((term: string) => {
      console.log(this.selectedOption);
      this.proformaService
        .search(term, this.userid)
        .then((proformas: any) => {
          this.currentSearchTerm = term;
          this.updatepedidos(proformas);
          console.log();
        });
    });
  }

  componentMethodName(event: any, isChecked: boolean, num:any) 
  {
    if (isChecked) {
      this.Array.push(num)
    }
    else {
      let index = this.Array.indexOf(num);
      this.Array.splice(index, 1);
    }
  }

 
  updatepedidos(pedidos: Paginated) {
    const pedidosWithUpdatedNavs = this.updateNavUrls(
      this.currentSearchTerm,
      pedidos
    );
    this.pedidos = pedidosWithUpdatedNavs;
  }

 

  updateNavUrls(term: string, pedidos: Paginated): Paginated {
    if (term) {
      if (pedidos.prev_page_url) {
        pedidos.prev_page_url +=
          `&term=${term}` + `&user_id=${this.userid}` + `&estado=PEDIDO`;
        // console.log(pedidos.prev_page_url);
      }
      if (pedidos.next_page_url) {
        pedidos.next_page_url +=
          `&term=${term}` + `&user_id=${this.userid}` + `&estado=PEDIDO`;
      }
    }
    return pedidos;
  }

  prevPage() {
    this.orderService
      .getPedidosAtUrl(
        this.pedidos.prev_page_url +
          `&user_id=${this.userid}` +
          `&estado=PEDIDO`
      )
      .then((pedidos: any) => {
        this.updatepedidos(pedidos);
      });
  }

  nextPage() {
    this.orderService
      .getPedidosAtUrl(
        this.pedidos.next_page_url +
          `&user_id=${this.userid}` +
          `&estado=PEDIDO`
      )
      .then((pedidos: any) => {
        this.updatepedidos(pedidos);
      });
  }

  search(term: string) {
    this.searchTermStream.next(term);
  }

  searchPage(value:number)
  {
    this.proformaService
    .getPedidosAtUrl2(value, this.userid)
      .then((pedidos: any) => {
        this.updatepedidos(pedidos);
      });

  }

  lisdOrder() {
    this.proformaService.getAll().subscribe(
      data => {
        this.orders = data;
        //  console.log(data);
      },
      error1 => {
        console.log(error1);
      }
    );
  }

  eliminar(id: string) {
    Swal.fire({
      title: 'Esta seguro de Eliminar la proforma?',
      text: 'Una vez eliminado, Ud no podra recuperar la proforma eliminada!',
      type: 'warning',
      showConfirmButton: true,
      showCancelButton: true
    }).then(willDelete => {
      if (willDelete.value) {

        this.proformaService.delete(id).subscribe(
          data => {
            this.proformaService.search('', this.userid).then((proformas: any) => {
              this.currentSearchTerm = '';
              this.updatepedidos(proformas);
              console.log(proformas);
            });
            Swal.fire(data);
          },
          error => {
            console.log(error.error);
          }
        );
      } else {
        Swal.fire('No se pudo eliminar');
      }

      console.log(willDelete);
    });
  }

  enviar(id:string)
  {
    Swal.fire({
      title: 'Esta seguro de eviar la proforma a pedido?',
      text: 'Una vez enviado, Ud no podra revertir el proceso!',
      type: 'warning',
      showConfirmButton: true,
      showCancelButton: true
    }).then(willDelete => {
      if (willDelete.value) {
        this.proformaService.enviarPedido(id).subscribe(
          data => {
            this.proformaService
              .getProformas(this.userid)
              .then(pedidos => (this.pedidos = pedidos));

            // this.warehouses = data;

            this.searchTermStream.subscribe((term: string) => {
              this.proformaService
                .search(term, this.userid)
                .then((pedidos: any) => {
                  this.currentSearchTerm = term;
                  this.updatepedidos(pedidos);
                });
            });
            Swal.fire(data);
          },
          error => {
            console.log(error.error);
          }
        );
      } else {
        Swal.fire('No se pudo eliminar');
      }

      console.log(willDelete);
    });





  }
showPDF(proforma_id:string)
{

  this.proformaService.imprimirPedido(proforma_id).subscribe(x => {
    // It is necessary to create a new blob object with mime-type explicitly set
    // otherwise only Chrome works like it should
    const newBlob = new Blob([x], { type: 'application/pdf' });

    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(newBlob);
      return;
    }

    // For other browsers:
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL(newBlob);

    const link = document.createElement('a');
    link.href = data;
    link.download = proforma_id + '.pdf';
    // this is necessary as link.click() does not work on the latest firefox
    link.dispatchEvent(
      new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      })
    );

    setTimeout(function() {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(data);
      link.remove();
    }, 100);
  });

}

}
